import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  possiblePrices: [],
}

const priceSlice = createSlice({
  name: 'price',
  initialState,
  reducers: {
    initialInfoPrice: (state, { payload: { total, presetPrice, needsPayment, possiblePrices, autoPricing } }) => {
      state.total = total
      state.needsPayment = needsPayment
      state.presetPrice = presetPrice
      state.possiblePrices = possiblePrices
      state.autoPricing = autoPricing
    },
    updatePrice: (state, action) => {
      state.total = action.payload
    },
    updatePresetPrice: (state, action) => {
      state.presetPrice = action.payload
    },
  },
})

export const { initialInfoPrice, updatePrice, updatePresetPrice } = priceSlice.actions
export default priceSlice.reducer
